export default {"src":"/_next/static/media/processes.a1ede48c.svg","height":53,"width":72};